import { Pipe, PipeTransform } from '@angular/core';
import {
  formatTimeNumber,
  minutesToHourAndMinutes,
} from 'server/shared/helpers/time';

@Pipe({
  name: 'time',
})
export class TimePipe implements PipeTransform {
  transform(time: number, asDuration = false) {
    if (!asDuration) {
      return formatTimeNumber(time);
    } else {
      return minutesToHourAndMinutes(time);
    }
  }
}
